// src/v3/ui/_common/components/layout/sidebar.tsx

import {
  CandlestickChart,
  CircleDollarSign,
  Clock,
  Database,
  FlaskConical,
  LayoutDashboard,
  Lightbulb,
  KeyRound,
  Menu,
  Wallet,
  X,
} from "lucide-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "../../lib/utils";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/signals", label: "Signals", icon: CandlestickChart },
  { to: "/symbols", label: "Symbols", icon: CircleDollarSign },
  { to: "/portfolio", label: "Portfolio", icon: Wallet },
  { to: "/settings/mcp", label: "MCP connections", icon: KeyRound },
  { to: "/ideas", label: "Ideas", icon: Lightbulb },
  { to: "/backtester", label: "Backtester", icon: FlaskConical },
  { to: "/scheduler", label: "Scheduler", icon: Clock },
  { to: "/datasource", label: "Data Sources", icon: Database },
];

export function Sidebar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="fixed left-4 top-4 z-50 rounded-md border p-2 md:hidden"
        onClick={() => setOpen(!open)}
        aria-label="Toggle sidebar"
      >
        {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
      </button>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}
      <aside
        className={cn(
          "fixed z-40 h-full w-60 flex-col border-r bg-card transition-transform md:flex md:translate-x-0",
          open ? "flex translate-x-0" : "flex -translate-x-full",
        )}
      >
        <nav className="flex-1 space-y-1 p-3 pt-12 md:pt-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </aside>
    </>
  );
}
